<div class="cpcontent">
    <h2>Bar Chart</h2>
<figure id="bar"></figure>
</div>
